import React from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { TpDataContext } from '../../../data/interfaces';
import { TpActionButtonsDefinition, TpDashboardContext, TpDashboardElement } from '../dashboard/interfaces';
import { FancyButton } from '../../../components/primitives/FancyButton';
import executeDashboardAction from './executeDashboardAction';

interface TpDashboardActionButtonsProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpActionButtonsDefinition;
}

function DashboardActionButtons({
  dataContext,
  parentElemDef,
  elemDef,
  dashboardContext,
}: TpDashboardActionButtonsProps) {
  const dispatch = useAppDispatch();

  function renderActionButton(actionDef: any) {
    return (
      <div key={actionDef.id} style={{ display: 'inline-block', marginRight: '15px' }}>
        <FancyButton
          iconName={actionDef.icon || 'arrow-right'}
          onClick={() => executeDashboardAction(dataContext, dashboardContext, actionDef, dispatch, {})}
        >
          {actionDef.name}
        </FancyButton>
      </div>
    );
  }

  return <div>{elemDef.actionDefs.map((actionDef) => renderActionButton(actionDef))}</div>;
}

export default DashboardActionButtons;
